import { defineMessages } from 'react-intl';

const FILTER_ACCESS_STRINGS = defineMessages({
  ADA: {
    defaultMessage: 'Wheelchair friendly'
  },
  WHEELCHAIR_FRIENDLY: {
    defaultMessage: 'Wheelchair friendly'
  },
  DOGS: {
    defaultMessage: 'Dog friendly'
  },
  DOGS_LEASH: {
    defaultMessage: 'Dogs on leash'
  },
  DOGS_ON_LEASH: {
    defaultMessage: 'Dogs on leash'
  },
  KIDS: {
    defaultMessage: 'Kid friendly'
  },
  KID_FRIENDLY: {
    defaultMessage: 'Kid friendly'
  },
  NO_DOGS: {
    defaultMessage: 'No dogs'
  },
  DOGS_NO: {
    defaultMessage: 'No dogs'
  },
  PARTIALLY_PAVED: {
    defaultMessage: 'Partially paved'
  },
  PAVED: {
    defaultMessage: 'Paved'
  },
  STROLLERS: {
    defaultMessage: 'Stroller friendly'
  },
  STROLLER_FRIENDLY: {
    defaultMessage: 'Stroller friendly'
  }
});

const FILTER_ACTIVITIES_STRINGS = defineMessages({
  BACKPACKING: {
    defaultMessage: 'Backpacking'
  },
  BIKE_TOURING: {
    defaultMessage: 'Bike touring'
  },
  BIRDING: {
    defaultMessage: 'Bird watching'
  },
  CAMPING: {
    defaultMessage: 'Camping'
  },
  CROSS_COUNTRY_SKIING: {
    defaultMessage: 'Cross-country skiing'
  },
  FISHING: {
    defaultMessage: 'Fishing'
  },
  HIKING: {
    defaultMessage: 'Hiking'
  },
  HORSEBACK_RIDING: {
    defaultMessage: 'Horseback riding'
  },
  MOUNTAIN_BIKING: {
    defaultMessage: 'Mountain biking'
  },
  OFF_ROAD_DRIVING: {
    defaultMessage: 'OHV/Off-road driving'
  },
  PADDLE_SPORTS: {
    defaultMessage: 'Paddle sports'
  },
  ROAD_BIKING: {
    defaultMessage: 'Road biking'
  },
  ROCK_CLIMBING: {
    defaultMessage: 'Rock climbing'
  },
  SCENIC_DRIVING: {
    defaultMessage: 'Scenic driving'
  },
  SKIING: {
    defaultMessage: 'Skiing'
  },
  SNOWSHOEING: {
    defaultMessage: 'Snowshoeing'
  },
  SURFING: {
    defaultMessage: 'Surfing'
  },
  TRAIL_RUNNING: {
    defaultMessage: 'Running'
  },
  RUNNING: {
    defaultMessage: 'Running'
  },
  VIA_FERRATA: {
    defaultMessage: 'Via ferrata'
  },
  WALKING: {
    defaultMessage: 'Walking'
  },
  NATURE_TRIPS: {
    defaultMessage: 'Nature trips'
  },
  BIRD_WATCHING: {
    defaultMessage: 'Bird watching'
  }
});

const FILTER_DIFFICULTIES_STRINGS = defineMessages({
  EASY: {
    defaultMessage: 'Easy'
  },
  MODERATE: {
    defaultMessage: 'Moderately challenging'
  },
  HARD: {
    defaultMessage: 'Challenging'
  }
});

const FILTER_FEATURE_TYPES_STRINGS = defineMessages({
  BEACH: {
    defaultMessage: 'Beach'
  },
  CAVE: {
    defaultMessage: 'Cave'
  },
  CITY_WALK: {
    defaultMessage: 'City walk'
  },
  EVENT: {
    defaultMessage: 'Event'
  },
  FOREST: {
    defaultMessage: 'Forest'
  },
  HISTORIC_SITE: {
    defaultMessage: 'Historic site'
  },
  HOT_SPRINGS: {
    defaultMessage: 'Hot springs'
  },
  LAKE: {
    defaultMessage: 'Lake'
  },
  PUB_WALK: {
    defaultMessage: 'Pub walk'
  },
  PUB_CRAWL: {
    defaultMessage: 'Pub walk'
  },
  RAILS_TRAILS: {
    defaultMessage: 'Rails trails'
  },
  RIVER: {
    defaultMessage: 'River'
  },
  VIEWS: {
    defaultMessage: 'Views'
  },
  WATERFALL: {
    defaultMessage: 'Waterfall'
  },
  WILD_FLOWERS: {
    defaultMessage: 'Wildflowers'
  },
  WILDLIFE: {
    defaultMessage: 'Wildlife'
  }
});

const FILTER_LENGTHS_STRINGS = defineMessages({
  SHORT: {
    defaultMessage: 'Short'
  },
  LONG: {
    defaultMessage: 'Long'
  }
});

const FILTER_OBSTACLES_STRINGS = defineMessages({
  BLOWDOWN: {
    defaultMessage: 'Blowdown'
  },
  BRIDGE_OUT: {
    defaultMessage: 'Bridge out'
  },
  BUGS: {
    defaultMessage: 'Bugs'
  },
  CLOSED: {
    defaultMessage: 'Closed'
  },
  FEE: {
    defaultMessage: 'Fee'
  },
  FLOODED: {
    defaultMessage: 'Flooded'
  },
  GREAT: {
    defaultMessage: 'Great!'
  },
  ICY: {
    defaultMessage: 'Icy'
  },
  MUDDY: {
    defaultMessage: 'Muddy'
  },
  NO_SHADE: {
    defaultMessage: 'No shade'
  },
  OFF_TRAIL: {
    defaultMessage: 'Off trail'
  },
  OVER_GROWN: {
    defaultMessage: 'Over grown'
  },
  PRIVATE_PROPERTY: {
    defaultMessage: 'Private property'
  },
  ROCKY: {
    defaultMessage: 'Rocky'
  },
  SCRAMBLE: {
    defaultMessage: 'Scramble'
  },
  SNOW: {
    defaultMessage: 'Snow'
  },
  WASHED_OUT: {
    defaultMessage: 'Washed out'
  }
});

const FILTER_ROUTE_TYPES_FILTER = defineMessages({
  LOOP: {
    defaultMessage: 'Loop'
  },
  OUT_AND_BACK: {
    defaultMessage: 'Out & back'
  },
  POINT_TO_POINT: {
    defaultMessage: 'Point to point'
  }
});

const FILTER_SORT_TYPES_STRINGS = defineMessages({
  BEST_MATCH: {
    defaultMessage: 'Best match'
  },
  MOST_POPULAR: {
    defaultMessage: 'Most popular'
  },
  NEWLY_ADDED: {
    defaultMessage: 'Newly added'
  },
  CLOSEST: {
    defaultMessage: 'Closest'
  },
  LIST_ORDER: {
    defaultMessage: 'List order'
  },
  DATE: {
    defaultMessage: 'Date'
  },
  NAME: {
    defaultMessage: 'Name'
  },
  RECENTLY_ADDED: {
    defaultMessage: 'Recently added'
  }
});

const FILTER_USAGES_STRING = defineMessages({
  LIGHT: {
    defaultMessage: 'Light'
  },
  MODERATE: {
    defaultMessage: 'Moderate'
  },
  HEAVY: {
    defaultMessage: 'Heavy'
  },
  EXTRA_HEAVY: {
    defaultMessage: 'Extra heavy'
  }
});

const FILTER_STRINGS = defineMessages({
  MORE_FILTERS: {
    defaultMessage: 'More filters'
  },
  TRAIL_LINKED: {
    defaultMessage: 'Linked to trail'
  },
  TRAIL_UNLINKED: {
    defaultMessage: 'Not linked to trail'
  },
  TRAIL_COMPLETION: {
    defaultMessage: 'Trail completion'
  },
  DIFFICULTY: {
    defaultMessage: 'Difficulty'
  },
  ACTIVITY: {
    defaultMessage: 'What to do'
  },
  ACTIVITY_LABEL: {
    defaultMessage: 'Activity'
  },
  FEATURES: {
    defaultMessage: 'What to see'
  },
  FEATURES_LABEL: {
    defaultMessage: 'Attractions'
  },
  SUITABILITY: {
    defaultMessage: 'Suitability'
  },
  PARK: {
    defaultMessage: 'Park'
  },
  CITY: {
    defaultMessage: 'City'
  },
  STATE: {
    defaultMessage: 'State'
  },
  COUNTRY: {
    defaultMessage: 'Country'
  },
  ELEV_GAIN: {
    defaultMessage: 'Elevation gain'
  },
  LENGTH: {
    defaultMessage: 'Length'
  },
  TIME: {
    defaultMessage: 'Time'
  },
  EST: {
    defaultMessage: 'Est.'
  },
  ROUTE_TYPE: {
    defaultMessage: 'Route type'
  },
  TRAIL_TRAFFIC: {
    defaultMessage: 'Trail traffic'
  },
  RATING: {
    defaultMessage: 'Rating'
  },
  SORT: {
    defaultMessage: 'Sort by'
  },
  SORT_LABEL: {
    defaultMessage: 'Sort'
  },
  DISTANCE_AWAY: {
    defaultMessage: 'Distance away'
  },
  AND_UP: {
    defaultMessage: '& up'
  },
  COMPLETED: {
    defaultMessage: 'Completed'
  },
  UNCOMPLETED: {
    defaultMessage: 'Not completed'
  },
  VERIFIED: {
    defaultMessage: 'Verified completed'
  },
  UNVERIFIED: {
    defaultMessage: 'Completed'
  },
  OPEN: {
    defaultMessage: 'Open'
  }
});

export {
  FILTER_ACCESS_STRINGS,
  FILTER_ACTIVITIES_STRINGS,
  FILTER_DIFFICULTIES_STRINGS,
  FILTER_FEATURE_TYPES_STRINGS,
  FILTER_LENGTHS_STRINGS,
  FILTER_OBSTACLES_STRINGS,
  FILTER_ROUTE_TYPES_FILTER,
  FILTER_SORT_TYPES_STRINGS,
  FILTER_USAGES_STRING,
  FILTER_STRINGS
};
